import {DownloadOutlined} from "@ant-design/icons";
import map from "lodash/map";
import Link from "next/link";
import isEmpty from "lodash/isEmpty";
import styles from "./DownloadSection.module.scss";

const DownloadSection = ({attachments}) => {

	return(
		<div className={styles.wrapper}>
			{map(attachments,(attachment,index) => {
				if(isEmpty(attachment?.fileUrl)){
					return ""
				}
				return(
					<div  key={`attachment-${index}`}>
						<Link href={attachment?.fileUrl}>
							<a target="_blank" download className={styles.item} >
								<DownloadOutlined className={styles.icon} />
								{attachment?.name}
							</a>
						</Link>
					</div>
				)
			})}
		</div>
	)
}
export default DownloadSection;